import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Heading from './heading';
import InputField from './InputField';
import SelectField from './select';
import Button from './button';
import {
    EmailValidation, matchWithPassword,
    PasswordValidation, FirstNameValidation,
    MobileValidation
} from './../../../library/validation';
import CountryCode from './../../../constants/common';
import { registerUser } from './../../../actions/userActions';
import ShowHidePassword from './hideShowPassword';
import APP from 'app';
const { Utils } = APP, { translateText } = Utils;
const { COUNTRY = [] } = CountryCode;

const countryCode = COUNTRY.map(data => {
    const { dial_code = '' } = data;
    return dial_code;
})
class RegisterComp extends Component {
    state = {
        userData: {
            role: 'CUSTOMER',
            code: '+91'
        },
        errMsg: false,
        backToLogin: false,
        registeredContent: false,
        showPassword: false,
        showConfirmPassword: false
    }

    onChangeHandler = (value, context) => {
        this.setState({
            userData: {
                ...this.state.userData,
                [context]: value
            }
        })
    }

    validateByField = (field) => {
        const { userData = {} } = this.state;
        const { email = '', password = '', name = '',
            mobile = '', confirmPassword = '', code = '' } = userData;
        const funcList = {
            "email": EmailValidation(email),
            "password": PasswordValidation(password),
            "name": FirstNameValidation(name),
            "mobile": MobileValidation(mobile, code),
            "confirmPassword": matchWithPassword(confirmPassword, password)
        }
        const validateStatus = funcList[field];
        if (validateStatus != true) {
            const { errMsg } = validateStatus;
            this.setErrMsg({ [`${field}Error`]: errMsg });
            return false;
        } else {
            this.setErrMsg({ [`${field}Error`]: '' });
            return true;
        }
    }

    validate = () => {
        let isValid = this.validateByField("email");
        isValid = this.validateByField("password") && isValid;
        isValid = this.validateByField("name") && isValid;
        isValid = this.validateByField("mobile") && isValid;
        isValid = this.validateByField('confirmPassword') && isValid;
        return isValid;
    }

    registerHandler = () => {
        const validateStatus = this.validate();
        if (validateStatus) {
            const data = this.state.userData;
            this.props.dispatch(registerUser(data));
        } else {
            this.setState({
                errMsg: true
            });
        }
    }

    setErrMsg = (userDataErrors) => {
        this.setState((prevState) =>
            ({
                userData: {
                    ...prevState.userData,
                    ...userDataErrors
                }
            })
        )
    }

    onKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            this.registerHandler();
        }
    }

    onBlur = (event, field) => {
        if (this.state.errMsg) {
            this.validateByField(field);
        }
    }

    registerdHandler = () => {
        if (typeof this.props.openRegisterHandler === 'function') {
            this.props.openRegisterHandler();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { registerSuccess = false } = nextProps;
        if (registerSuccess) {
            this.setState({
                registeredContent: !this.state.registeredContent,
                backToLogin: !this.state.backToLogin
            })
        }
    }

    showHidePassword = () => {
        this.setState({
            showPassword: !this.state.showPassword
        })
    }

    showConfirmPassword = () => {
        this.setState({
            showConfirmPassword: !this.state.showConfirmPassword
        })
    }

    render() {
        const { userData = {}, backToLogin = false, registeredContent = false, showPassword = false, showConfirmPassword = false } = this.state;
        return (
            <Fragment>
                {!backToLogin ?
                    <Fragment>
                        <Heading
                            title={translateText('registerHere', 'B2CRegister')}
                        />
                        <InputField
                            type='text'
                            placeholder={translateText('fullName', 'B2CRegister')}
                            context='name'
                            onChangeHandler={this.onChangeHandler}
                            name='name'
                            value={userData['name']}
                            errorText={userData['nameError']}
                            handleKeyDown={this.onKeyDown}
                            onBlur={this.onBlur}
                        />
                        <InputField
                            type='email'
                            placeholder={translateText('emailAddress', 'B2CRegister')}
                            context='email'
                            onChangeHandler={this.onChangeHandler}
                            name='email'
                            value={userData['email']}
                            errorText={userData['emailError']}
                            handleKeyDown={this.onKeyDown}
                            onBlur={this.onBlur}
                        />
                        <div className="b2cform__field--mobilewrap">
                            <SelectField
                                data={countryCode}
                                selectClassName="b2cform__field--countrycode"
                                placeholder={translateText('code', 'B2CRegister')}
                                selectedHandler={this.onChangeHandler}
                                context='code'
                                value={userData['code']}
                            />
                            <InputField
                                type='text'
                                placeholder={translateText('mobile', 'B2CRegister')}
                                context='mobile'
                                onChangeHandler={this.onChangeHandler}
                                name='mobile'
                                value={userData['mobile']}
                                errorText={userData['mobileError']}
                                handleKeyDown={this.onKeyDown}
                                onBlur={this.onBlur}
                                inputClassName={'b2cform__field--mobilenumber'}
                            />
                        </div>
                        <div className="b2c__loginwrap--showhidepassword">
                            <InputField
                                type={showPassword ? 'text' : 'password'}
                                placeholder={translateText('password', 'B2CRegister')}
                                context='password'
                                onChangeHandler={this.onChangeHandler}
                                name='password'
                                value={userData['password']}
                                errorText={userData['passwordError']}
                                handleKeyDown={this.onKeyDown}
                                onBlur={this.onBlur}
                            />
                            <ShowHidePassword
                                showPassword={showPassword}
                                showHidePassword={this.showHidePassword}
                            />
                        </div>
                        <div className="b2c__loginwrap--showhidepassword">
                            <InputField
                                type={showConfirmPassword ? 'text' : 'password'}
                                placeholder={translateText('confirmPassword', 'B2CRegister')}
                                context='confirmPassword'
                                onChangeHandler={this.onChangeHandler}
                                name='confirmPassword'
                                value={userData['confirmPassword']}
                                errorText={userData['confirmPasswordError']}
                                handleKeyDown={this.onKeyDown}
                                onBlur={this.onBlur}
                            />
                            <ShowHidePassword
                                showPassword={showConfirmPassword}
                                showHidePassword={this.showConfirmPassword}
                            />
                        </div>
                        <Button
                            type='button'
                            onSubmitHandler={this.registerHandler}
                            displayLabel={translateText('submitBtn', 'B2CRegister')}
                        />
                    </Fragment> :
                    <Fragment>
                        {registeredContent ?
                            <p className="b2cform__field--registered">
                                {translateText('successfullyRegisteredMsg', 'B2CRegister')}
                                <span onClick={this.registerdHandler} className="b2cform__field--clickhere"> {translateText('clickHere', 'B2CRegister')}</span> {translateText('toLogin', 'B2CRegister')}</p> : ''}
                    </Fragment>
                }
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    const { userinfos = {} } = state;
    const { userInfo = {}, registerSuccess = false } = userinfos;
    return {
        userInfo,
        registerSuccess
    }
};

const mapDispatchToProps = dispatch => {
    let actions = bindActionCreators({
        registerUser
    });
    return { actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterComp);